class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details') || this.querySelector('.detail-block');
    this.summaryToggle = this.querySelector('summary');

    this.input = this.querySelector('#search_query');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'touchstart',
      this.onSummaryClick.bind(this)
    );
    this.querySelector('button[type="button"]').addEventListener(
      'click',
      this.close.bind(this)
    );

    this.summaryToggle.setAttribute('role', 'button');

    this.input.addEventListener('focus', this.open.bind(this));
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    this.detailsContainer.hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    console.log('onBodyClick', event.target);
    if (event.target.closest('.ss__autocomplete, .ss__autocomplete--default')) return;
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) {
      this.close(false);
    }

  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.detailsContainer.setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');
    document.querySelector('html').classList.add('overflow-hidden');

    trapFocus?.call(this,
      this.detailsContainer.querySelector('input.search__input')
    );
  }

  close(focusToggle = true) {
    if (!this.isOpen()) return;
    removeTrapFocus?.call(this, focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    document.querySelector('html').classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
